export default {
  data: () => ({
    previewModal: false,
    previewModalText: '',
    previewModalTitle: ''
  }),
  methods: {
    // @vuese
    // Otworzenie modala z zawartością wniosku
    showContentModal(title, text) {
      this.previewModal = true;
      this.previewModalText = text;
      this.previewModalTitle = title;
    },
    // @vuese
    // Zamknięcie modala z zawartością wniosku
    closeContentModal() {
      this.previewModal = false;
      this.previewModalText = '';
      this.previewModalTitle = '';
    }
  }
};
